<template>
    <!-- Основной контейнеер страниц -->
    <MainLayout>
        <!-- Форма для заполнения данных о товаре -->
        <DropPageForm 
        :is-from-abroad="true"
        :order-id="orderId"
        />
        
    </MainLayout>   

</template>

<script>
import DropPageForm from '@/components/DropPageForm.vue';
import MainLayout from '@/components/MainLayout.vue';

export default {
    components: {
        DropPageForm,
        MainLayout,
    },
    props: {
        orderId: {
            type: Number,
            required: true,
        }
    },
    mounted() {
        console.log('🚀 Компонент FromAbroadOrderDataPage смонтирован с orderId:', this.orderId);
    }
}

</script>

<style scoped>

</style>